const GET_FORECAST_BILL_AZURE = "GET_FORECAST_BILL_AZURE";
const GET_FORECAST_BILL_AZURE_SUCCESS = "GET_FORECAST_AZURE_BILL_SUCCESS";
const GET_FORECAST_BILL_AZURE_ERROR = "GET_FORECAST_AZURE_BILL_ERROR";

const GET_DAILY_FORECAST_BILL_AZURE = "GET_DAILY_FORECAST_BILL_AZURE";
const GET_DAILY_FORECAST_BILL_AZURE_SUCCESS =
  "GET_DAILY_FORECAST_AZURE_BILL_SUCCESS";
const GET_DAILY_FORECAST_BILL_AZURE_ERROR =
  "GET_DAILY_FORECAST_AZURE_BILL_ERROR";

const GET_RESOURCEGROUP_FORECAST_BILL_AZURE =
  "GET_RESOURCEGROUP_FORECAST_BILL_AZURE";
const GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_SUCCESS =
  "GET_RESOURCEGROUP_DAILY_FORECAST_AZURE_BILL_SUCCESS";
const GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_ERROR =
  "GET_RESOURCEGROUP_DAILY_FORECAST_AZURE_BILL_ERROR";

const GET_LOCATION_FORECAST_BILL_AZURE = "GET_LOCATION_FORECAST_BILL_AZURE";
const GET_LOCATION_DAILY_FORECAST_BILL_AZURE_SUCCESS =
  "GET_LOCATION_DAILY_FORECAST_AZURE_BILL_SUCCESS";
const GET_LOCATION_DAILY_FORECAST_BILL_AZURE_ERROR =
  "GET_LOCATION_DAILY_FORECAST_AZURE_BILL_ERROR";

export {
  GET_LOCATION_FORECAST_BILL_AZURE,
  GET_LOCATION_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_LOCATION_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_FORECAST_BILL_AZURE,
  GET_FORECAST_BILL_AZURE_SUCCESS,
  GET_FORECAST_BILL_AZURE_ERROR,
  GET_DAILY_FORECAST_BILL_AZURE,
  GET_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_RESOURCEGROUP_FORECAST_BILL_AZURE,
  GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_ERROR,
};
